import { useId, useState } from "react";
import { getLocalized, HealthLang, LocalizedString } from "./healthTypes";
import { healthBody, healthCardTitle, healthFocusVisible } from "./healthVisualStyles";

interface HealthFaqItemProps {
    question: LocalizedString;
    answer: LocalizedString;
    lang: HealthLang;
    defaultOpen?: boolean;
}

export function HealthFaqItem({
    question,
    answer,
    lang,
    defaultOpen = false,
}: HealthFaqItemProps) {
    const [open, setOpen] = useState(defaultOpen);
    const panelId = useId();
    const q = getLocalized(question, lang);
    const a = getLocalized(answer, lang);

    return (
        <div className="border-b border-grey-200 text-left last:border-b-0">
            <button
                type="button"
                aria-expanded={open}
                aria-controls={panelId}
                onClick={() => setOpen(!open)}
                className={`flex min-h-[56px] w-full items-start justify-between gap-4 py-5 text-left transition-colors hover:text-teal-500 ${healthFocusVisible}`}
            >
                <span className={`${healthCardTitle} pr-2`}>{q}</span>
                <span
                    className="shrink-0 pt-0.5 text-xl font-semibold leading-none text-teal-500"
                    aria-hidden="true"
                >
                    {open ? "\u2212" : "+"}
                </span>
            </button>
            {open && (
                <div id={panelId} className="pb-6 text-left">
                    <p className={healthBody}>{a}</p>
                </div>
            )}
        </div>
    );
}
